import { useEffect } from 'react'
import {
  COOKIE_AFFILIATES,
  COOKIE_AUTHENTICATION,
  COOKIE_EXPERIMENT,
  COOKIE_LANGUAGE,
  COOKIE_MARKET,
  COOKIE_MOBILE_APP,
  COOKIE_MOBILE_RATE,
  COOKIE_PURCHASE,
  COOKIE_QUERY_TYPE,
  COOKIE_RETURN_URL,
  COOKIE_SUBSCRIPTION_MODAL_CLOSED,
  COOKIE_TRACKING,
  REJECT_TRACKING_COOKIE_NAME,
} from 'src/constants/cookies'
import { COOKIE_PROPERTIES_VISITED } from 'src/effects/PropertiesVisited/constants'

// Extend Window interface for React Native WebView
declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void
    }
  }
}

export const COOKIES_SYNC = 'COOKIES_SYNC'
export const COOKIES_SYNC_DEBOUNCE_TIME = 300

const COOKIES_WHITE_LIST = [
  COOKIE_AFFILIATES,
  COOKIE_AUTHENTICATION,
  COOKIE_EXPERIMENT,
  COOKIE_LANGUAGE,
  COOKIE_MARKET,
  COOKIE_MOBILE_APP,
  COOKIE_MOBILE_RATE,
  COOKIE_PROPERTIES_VISITED,
  COOKIE_PURCHASE,
  COOKIE_QUERY_TYPE,
  COOKIE_RETURN_URL,
  COOKIE_RETURN_URL,
  COOKIE_SUBSCRIPTION_MODAL_CLOSED,
  COOKIE_TRACKING,
  REJECT_TRACKING_COOKIE_NAME,
]

export function useSyncAppCookies() {
  useEffect(() => {
    // Check if cookieStore API is available
    if (
      !globalThis?.window?.cookieStore ||
      typeof globalThis?.window?.cookieStore.addEventListener !== 'function'
    ) {
      return undefined
    }

    let debounceTimer: NodeJS.Timeout | null = null

    const handleCookieChange = async () => {
      const cookies = (await globalThis?.window?.cookieStore?.getAll()) ?? []

      const cookiesToUpdate = cookies.filter(cookie =>
        COOKIES_WHITE_LIST.includes(cookie.name ?? '')
      )

      if (!cookiesToUpdate.length) return

      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }

      debounceTimer = setTimeout(() => {
        if (globalThis.window && 'ReactNativeWebView' in globalThis.window) {
          const reactNativeWebView = globalThis.window.ReactNativeWebView

          reactNativeWebView?.postMessage(
            JSON.stringify({
              type: COOKIES_SYNC,
              data: cookiesToUpdate,
            })
          )
        }
        debounceTimer = null
      }, COOKIES_SYNC_DEBOUNCE_TIME) // 300ms debounce
    }

    globalThis.window.cookieStore.addEventListener('change', handleCookieChange)

    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer)
      }
      globalThis.window?.cookieStore?.removeEventListener('change', handleCookieChange)
    }
  }, [])
}
